import { Box } from "@mui/material";
import KsbActionButton from "../../../../../2_ksbHub/components/KsbActionButton";
import { LocalFireDepartment, Thermostat, WbSunny } from "@mui/icons-material";

export const ChartLegend = ({
  showTemperature,
  setShowTemperature,
  showAskoma,
  setShowAskoma,
  showFeedin,
  setShowFeedin,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        gap: 4,
        mt: 2,
        mb: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 1,
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
          <KsbActionButton
            label="Askoma Verbrauch"
            onClick={() => setShowAskoma((prev) => !prev)}
            backgroundColor={showAskoma ? "#2196F3" : undefined}
            variant={showAskoma ? "contained" : "outlined"}
            icon={<LocalFireDepartment />}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
          <KsbActionButton
            label="PV Überschuss"
            onClick={() => setShowFeedin((prev) => !prev)}
            backgroundColor={showFeedin ? "#4CAF50" : undefined}
            variant={showFeedin ? "contained" : "outlined"}
            icon={<WbSunny />}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
          <KsbActionButton
            label="Temperatur"
            onClick={() => setShowTemperature((prev) => !prev)}
            backgroundColor={showTemperature ? "#FF9800" : undefined}
            variant={showTemperature ? "contained" : "outlined"}
            icon={<Thermostat />}
          />
        </Box>
      </Box>
    </Box>
  );
};
